import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.3292 36C21.0814 35.9999 20.8386 35.9309 20.6278 35.8008C20.417 35.6707 20.2465 35.4845 20.1354 35.2631L16.1787 27.3458C16.0719 27.1318 16.0245 26.893 16.0413 26.6545C16.0581 26.4159 16.1385 26.1861 16.2741 25.9891L22.6629 17.335L14.0087 23.7212C13.812 23.8569 13.5825 23.9373 13.3441 23.9541C13.1057 23.9709 12.8672 23.9234 12.6533 23.8167L4.73349 19.8599C4.50176 19.7432 4.30913 19.5613 4.17921 19.3367C4.04929 19.112 3.98771 18.8544 4.00203 18.5953C4.01635 18.3362 4.10594 18.0869 4.25983 17.8779C4.41371 17.669 4.62521 17.5095 4.86839 17.4189L30.201 8.0826C30.4399 7.9943 30.6992 7.97635 30.9481 8.03088C31.1969 8.08541 31.4249 8.21014 31.6051 8.39028C31.7852 8.57042 31.9099 8.79842 31.9645 9.04727C32.019 9.29612 32.001 9.55539 31.9127 9.79435L22.5777 35.1282C22.4878 35.3723 22.3284 35.5846 22.1192 35.7391C21.91 35.8936 21.6601 35.9834 21.4004 35.9975L21.3292 36Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSendFilled);
export default ForwardRef;
